import { Link } from "gatsby"
import React from "react"

import { iNavSidebarLink } from "../types"
import { DarkAppButton } from "./Buttons"

export const NavSidebarExternalLink: React.FC<{
  to: string
  children: object
  className?: string
  [id: string]: any
}> = props => {
  const { to, children, className, ...rest } = props
  return (
    <a href={to} className={className} {...rest}>
      {children}
    </a>
  )
}

export const NavSidebarLink: React.FC<iNavSidebarLink> = ({
  title,
  to,
  external,
  Icon,
  wrapper,
  onClick,
  ButtonComponent = DarkAppButton,
  wrapperClassName = "flex justify-center my-2 px-6",
}) => {
  const LinkComponent = external ? Link : NavSidebarExternalLink
  const Button = (
    <ButtonComponent
      title={title}
      Icon={Icon}
      className="text-lg sm:text-base"
      onClick={() => (onClick ? onClick() : null)}
    />
  )
  if (wrapper) {
    const WrappedButton = wrapper(
      <div className={wrapperClassName}>{Button}</div>
    )
    return <WrappedButton />
  }
  if (!to) {
    return <div className={wrapperClassName}>{Button}</div>
  }
  return (
    <LinkComponent to={to} className={wrapperClassName}>
      {Button}
    </LinkComponent>
  )
}
